import { Email, Sms } from '@mui/icons-material';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import {
  IRIS_MAILTO_HREF,
  IRIS_PHONE_DISPLAY,
  IRIS_SMS_HREF
} from '@/constants/iris';
import { tDynamic } from '@/lib/i18n';
import { brandVars as brand } from '@/theme/theme';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

export const LandingCTA: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, sm: 10, lg: 12 },
        px: { xs: 2, sm: 3 },
        background: brand.gradients.cta
      }}
    >
      <Container maxWidth="md">
        <Stack sx={{ alignItems: 'center', textAlign: 'center', gap: 3 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '1.75rem', sm: '2rem', lg: '2.25rem' },
              color: 'white'
            }}
          >
            {t('landing:cta.title')}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: '1rem', sm: '1.125rem' },
              color: 'rgba(255, 255, 255, 0.85)',
              maxWidth: 520
            }}
          >
            {t('landing:cta.subtitle')}
          </Typography>

          <Stack
            sx={{
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
              alignItems: 'center'
            }}
          >
            <Button
              component="a"
              href={IRIS_SMS_HREF}
              variant="contained"
              size="large"
              startIcon={<Sms />}
              sx={{
                bgcolor: 'white',
                color: 'primary.main',
                px: { xs: 4, sm: 5 },
                py: { xs: 1.5, sm: 2 },
                fontSize: { xs: '1rem', sm: '1.125rem' },
                fontWeight: 600,
                '&:hover': { bgcolor: 'grey.100' }
              }}
            >
              {tDynamic(t, 'landing:cta.textCta', {
                phone: IRIS_PHONE_DISPLAY
              })}
            </Button>
            <Button
              component="a"
              href={IRIS_MAILTO_HREF}
              variant="outlined"
              size="large"
              startIcon={<Email />}
              sx={{
                borderColor: 'rgba(255,255,255,0.6)',
                color: 'white',
                px: { xs: 4, sm: 5 },
                py: { xs: 1.5, sm: 2 },
                fontSize: { xs: '1rem', sm: '1.125rem' },
                fontWeight: 600,
                '&:hover': {
                  borderColor: 'white',
                  bgcolor: 'rgba(255,255,255,0.1)'
                }
              }}
            >
              {t('landing:cta.emailCta')}
            </Button>
          </Stack>

          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255, 255, 255, 0.75)',
              fontSize: { xs: '0.75rem', sm: '0.875rem' }
            }}
          >
            {t('landing:cta.benefits')}
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};
